import { useFormContext, TextInput } from 'framework/form';
import BudgetForm from './BudgetForm';
import TeamInputList from '../сomponents/TeamInputList';
import { Button } from 'framework/ui/mui-builder';
import FormElement from './common/FormElement';
import { useNavigate } from 'react-router-dom';
import { Box, Grid2 as Grid, Stack, Typography } from '@mui/material';
import SOWForm from './SOWForm';

const ProjectUpdateForm = () => {
  const { submitForm, isSubmitEnabled } = useFormContext();
  const navigate = useNavigate();

  return (
    <Stack spacing={2}>
      <Grid container spacing={2} size={12}>
        <Grid size={3}>
          <TextInput source="inputData.accountId" label="Account" disabled />
        </Grid>
        <Grid size={3}>
          <TextInput source="inputData.opportunityId" label="Opportunity" disabled />
        </Grid>
        <Grid size={3}>
          <TextInput source="project.existingProject.name" label="Related DaVinci project" disabled />
        </Grid>
      </Grid>
      <>
        <FormElement title={'SOW information'}>
          <SOWForm source={'sow'} />
        </FormElement>

        <FormElement title={'Budget information'}>
          <BudgetForm source={'budget'} expectedStructureSource={'team.expectedStructure'} isUpdate />
        </FormElement>
        <FormElement title="Team structure">
          <TeamInputList isUpdate source={'team.expectedStructure'} />
        </FormElement>
        <Typography color="textSecondary">
          Changing the team structure may affect current assignments. Staffing coordinators will be notified of the
          updates.
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'end', justifyContent: 'flex-end', mt: 1, gap: 1 }}>
          <Button variant="outlined" onClick={() => navigate(navigate.length)} disabled={!isSubmitEnabled}>
            Cancel
          </Button>
          <Button variant="contained" onClick={() => submitForm?.()} disabled={!isSubmitEnabled}>
            Submit
          </Button>
        </Box>
      </>
    </Stack>
  );
};

export default ProjectUpdateForm;
